import { useContext, useEffect } from "react";
import ProductManagement from "../../components/ProductManagement";
import { AppContext } from "../../contexts/AppContext";
import { useParams } from "react-router-dom";

const ProductManagementPage: React.FC = () => {
  const { findAndSetStore } = useContext(AppContext);
  const { storeId } = useParams<{ storeId: string }>();
  useEffect(() => {
    if (!storeId) return;
    findAndSetStore(storeId);
  }, [storeId]);

  return <ProductManagement />;
};

export default ProductManagementPage;
